import React, { Component } from 'react';
import './css/loading.css';

class Loading extends Component {

  render() {
    return (
      <div className="Loading">
        <p className="Loading-text">
          Preparing your questions...
        </p>
      </div>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/loading.js